/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Query_Keys } from "../../../lib/queryKeys";
import { mergeQueryKeys, getBaseQueryKey } from "../utils/queryKeyHelpers";
import { userDropdownRefreshKeys } from "./sharedRefreshKeys";

const networkGuestListRefreshKeys = mergeQueryKeys(
  getBaseQueryKey(Query_Keys.network_guests),
  getBaseQueryKey(Query_Keys.global_employee_search),
  getBaseQueryKey(Query_Keys.search_guests),
  getBaseQueryKey(Query_Keys.guest_details),
  getBaseQueryKey(Query_Keys.associated_guest_restaurants),
  getBaseQueryKey(Query_Keys.guest_activity_log),
  getBaseQueryKey(Query_Keys.employees),
  getBaseQueryKey(Query_Keys.employee_list),
  getBaseQueryKey(Query_Keys.audience_per_restaurant),
  getBaseQueryKey(Query_Keys.dashboard_audience),
  getBaseQueryKey(Query_Keys.convertible_restaurants),
  userDropdownRefreshKeys
);

const networkGuestArchiveRefreshKeys = mergeQueryKeys(
  networkGuestListRefreshKeys,
  getBaseQueryKey(Query_Keys.archived_employees)
);

const discountCardAssignmentRefreshKeys = mergeQueryKeys(
  getBaseQueryKey(Query_Keys.group_members),
  getBaseQueryKey(Query_Keys.employee_discount_report),
  getBaseQueryKey(Query_Keys.discount_card_logs),
  getBaseQueryKey(Query_Keys.dynamic_discount_events_matrix),
  getBaseQueryKey(Query_Keys.network_guest_discount_cards)
);

const networkGuestArchiveDiscountRefreshKeys = mergeQueryKeys(
  networkGuestArchiveRefreshKeys,
  discountCardAssignmentRefreshKeys
);

const networkGuestDiscountRefreshKeys = mergeQueryKeys(
  networkGuestListRefreshKeys,
  discountCardAssignmentRefreshKeys
);

// The card view shows special perq group members by name, so a renamed guest must refetch it.
const networkGuestUpdateRefreshKeys = mergeQueryKeys(
  networkGuestListRefreshKeys,
  getBaseQueryKey(Query_Keys.show_discount_card)
);

export const networkGuestMutationKeyGroups = {
  create: networkGuestListRefreshKeys,
  update: networkGuestUpdateRefreshKeys,
  delete: networkGuestArchiveDiscountRefreshKeys,
  restore: networkGuestArchiveRefreshKeys,
  discountCardAssign: networkGuestDiscountRefreshKeys,
  discountCardRevoke: networkGuestDiscountRefreshKeys,
};
